// extracted by mini-css-extract-plugin
export default {"container":"TrustBadges_container__VRCMt","badge":"TrustBadges_badge__XKDFY","icon":"TrustBadges_icon__oHmOd","text":"TrustBadges_text__zuf1k"};